import React from "react";
import PropTypes from "prop-types";
import { css } from "glamor";

import Title from "./Title";

const styles = {
    pageHeader: css({
        background: "#1b75bc !important",
        color: "#FFF",
        marginBottom: "60px",
        padding: "24px 50px",
        " .antd-pro-description-list-term": {
            color: "#FFF !important",
            fontWeight: "bold",
        },
        " .antd-pro-description-list-detail": {
            color: "#FFF !important",
        },
        " a": {
            color: "#FFF",
            textDecoration: "underline",
        },

        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
    }),

    rightContent: css({
        textAlign: "right",
        marginLeft: 10,
    }),
};

const PageHeader = ({ title, leftContent, rightContent }) => {
    return (
        <div {...styles.pageHeader}>
            <div>
                <Title>{title}</Title>

                <div>{leftContent}</div>
            </div>
            <div {...styles.rightContent}>{rightContent}</div>
        </div>
    );
};

PageHeader.propTypes = {
    title: PropTypes.element,
    leftContent: PropTypes.element,
    rightContent: PropTypes.element,
};

export default PageHeader;
